module.exports = __webpack_public_path__ + "static/media/envase2.7629459f.jpg";